import {ReviewEntry} from "src/app/model/ReviewEntry";
import FileSaver from "file-saver";
import {v4 as uuid} from "uuid";
import {generateReviewUrl} from "src/app/util/ReviewUrlUtil";
import {CaseResult} from "src/app/model/lighthouse/ManagementModels";
import {_ManagementTableFormatters} from "src/app/config/ManagementTableConfig";

export namespace CsvUtil {
    // Matches the Case Activity table's displayed columns (Take Action excluded).
    const CASE_CSV_HEADER = [
        'Case ID', 'DP ID', 'Reference Type', 'Case Type', 'Case Sub Type', 'Creation Date',
        'Enforcement Type', 'Country', 'Audit Type', 'Case Status'
    ].join(',');

    /** Escapes a CSV field (wraps in quotes when it contains a comma, quote or newline). */
    const csvField = (value: unknown): string => {
        const str = value == null ? '' : String(value);
        return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
    };

    /** Downloads the given Case Audit rows as a CSV (client-side), matching the review-page pattern. */
    export function generateCaseCsv(rows: CaseResult[] | undefined) {
        if (rows == undefined || rows.length == 0) {
            return;
        }
        const {formatDate, formatAuditType} = _ManagementTableFormatters;
        const body = rows.map(r => [
            r.caseId,
            r.referenceId,
            r.referenceSubType || '',
            r.caseType || '',
            r.caseSubType || '',
            formatDate(r.creationDate),
            r.caseSubType || '',   // enforcement type == caseSubType (no separate response field)
            r.country,
            formatAuditType(r.auditType),
            r.status
        ].map(csvField).join(',')).join('\n');

        const blob = new Blob(['\uFEFF' + CASE_CSV_HEADER + '\n' + body], {
            type: "text/plain;charset=utf-8"
        });
        FileSaver.saveAs(blob, uuid() + ".csv");
    }

    export function generateCsv(rows: ReviewEntry[] | undefined, header: string) {
        if (rows == undefined || rows.length == 0) {
            return;
        }
        let content = header;
        content += '\n';
        content += rows.map(row => generateCsvRow(row)).join("\n");

        const exportContent = '\uFEFF';
        const blob = new Blob([exportContent + content], {
            type: "text/plain;charset=utf-8"
        });
        const randomName = uuid();
        const fileName = randomName + ".csv"
        FileSaver.saveAs(blob, fileName);
    }

    const generateCsvRow = (row: ReviewEntry) => {
        const array = [];
        array.push(row.referenceSubType);
        array.push(row.country);
        array.push(row.referenceId);
        array.push(row.providerId);
        array.push(row.reviewId);
        array.push(row.caseType);
        array.push(row.caseSubType);
        array.push(row.creationDate);
        array.push(row.primaryCaseCompletionDate || "");
        array.push(row.secondaryCaseCompletionDate || "");
        array.push(row.reviewStatus);
        array.push(row.reviewResult);
        array.push(generateReviewUrl(row.reviewId));
        return array.join(",");
    }
}